import React, { Component } from 'react';

class ThankYou extends Component {
    constructor(props) {
        super(props);
    }
    state = {  }
    render() { 
        return (
            <div className="container">
                <h1>Fehler</h1>
                <p>Bei der Übermittlung deiner Daten ist ein Fehler aufgetreten. Deine Daten wurden nicht verarbeitet.</p>
            </div>
        );
    }
}
 
export default ThankYou;